import { render } from "./MyGpsDevice.vue?vue&type=template&id=2bbd06aa"
import script from "./MyGpsDevice.vue?vue&type=script&lang=js"
export * from "./MyGpsDevice.vue?vue&type=script&lang=js"

import "./MyGpsDevice.vue?vue&type=style&index=0&id=2bbd06aa&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__